import React, { Component } from 'react';
import i18n from 'kodyl-js/i18n/react';
import { connect } from 'react-redux';
import { cancelSubscription } from '../../redux/modules/subscriptions';
import { event } from '../../redux/modules/app';
import { formatDateTime } from '../../utils/format';

@connect(
  () => ({}),
  { cancelSubscription, event }
)
@i18n
class SubscriptionPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unsubscribe: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { subscription } = this.props;
    if (subscription.renew !== nextProps.subscription.renew) {
      this.setState({ unsubscribe: false });
    }
  }

  unsubscribe = () => {
    const { subscription, setSubscription, event } = this.props;
    event({
      action: 'subscription/cancel-intent',
      data: { subscriptionId: subscription._id }
    });
    setSubscription(subscription);
    // this.setState({ unsubscribe: true });
  };

  //TODO: NOT IN USE
  unsubscribeConfirm = () => {
    if (this.state.unsubscribe === true) {
      this.props
        .cancelSubscription(this.props.subscription._id)
        .then(action => {
          const { subscription, setSubscription } = this.props;
          setSubscription(subscription);
          return action;
        });
    }
  };

  render() {
    const { subscription } = this.props;

    const { startingAt, canceledAt, endingAt } = subscription;
    const ends = new Date(endingAt[0]);
    const nextSub = subscription.nextSubscription;
    // @deprecated
    const expired = ends.getTime() < Date.now();

    return (
      <div>
        <div className="panel panel-primary" key={subscription._id}>
          <div className="panel-heading">
            <h3 style={{ margin: 0 }}>
              {this.i18n(subscription.product.label)}
            </h3>
          </div>
          {nextSub?.renew || subscription.renew ? (
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                {this.i18n('Active since %s', formatDateTime(startingAt))}
              </li>
              <li className="list-group-item subscription-product">
                {subscription.product.price}{' '}
                {nextSub?.renew && `(overgår til ${nextSub.product.price})`}
              </li>
              <li className="list-group-item">
                {this.i18n(
                  'Automatic renewal %s',
                  formatDateTime(nextSub?.endingAt || endingAt)
                )}
              </li>
              <li className="list-group-item">
                {this.state.unsubscribe === true ? (
                  <span>
                    {this.i18n(
                      'Are you sure, you want to cancel your subscription?'
                    )}
                    <br />
                    <a onClick={this.unsubscribeConfirm}>
                      {this.i18n('Yes, please cancel my subscription')}
                    </a>
                  </span>
                ) : (
                  <a className="unsubscribe" onClick={this.unsubscribe}>
                    {this.i18n(
                      'Unsubscribe my %s',
                      this.i18n(subscription.product.label)
                    )}
                  </a>
                )}
              </li>
            </ul>
          ) : (
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                {this.i18n('Active since %s', formatDateTime(startingAt))}
              </li>
              <li className="list-group-item">{subscription.product.price}</li>
              {canceledAt ? (
                <li className="list-group-item">
                  {this.i18n('Opsagt den %s', formatDateTime(canceledAt))}
                </li>
              ) : null}
              <li className="list-group-item">
                <i
                  className="fa fa-warning"
                  style={{ color: expired ? 'red' : 'orange' }}
                />{' '}
                {this.i18n(
                  expired ? 'Expired %s' : 'Expires %s',
                  formatDateTime(endingAt)
                )}
              </li>
            </ul>
          )}
        </div>
        {nextSub ? (
          <div className="alert alert-warning">
            <h5>
              {this.i18n(
                'Din boligsøgerannonce vil skift til %s den %s',
                nextSub.product?.price,
                formatDateTime(subscription.ends)
              )}
            </h5>
          </div>
        ) : !subscription.renew && !expired ? (
          <div>
            <h5>
              {this.i18n(
                'Din boligsøgerannonce er afmeldt til udløb %s',
                formatDateTime(subscription.ends)
              )}
            </h5>
          </div>
        ) : null}
      </div>
    );
  }
}

export default SubscriptionPanel;
